export const PL = {
  message: {
    banner:
      "Due to a technical issue, all the data cannot be published. We are working on it. We apologise for the inconvenience.",
    in: "En",
    loadingText: "Chargement... Veuillez patienter",
    selectCustomer: "Wybierz klienta",
    offline: "Strona w trakcie konserwacji",
    refer: "Odnieść się do warunków użytkowania",
    error: {
      userNotFound: "Aucun utilisateur trouvé",
      noToken: "Ce lien n'est plus valide",
    },
    alert: {
      mail: "Aktywuj powiadomienia pocztą elektroniczną",
      sms: "Aktywuj powiadomienia SMS",
      battery: "alerty baterii",
      disclamer:
        "oparte na progach zdefiniowanych przez Akiem Leasing i odnoszące się do lokomotyw wyposażonych w skrzynki Railster",
      sralert: "Alarm",
      quotation: "Quotation alert",
      quotationLabel:
        "Po aktywowaniu tej opcji użytkownik będzie otrzymywać powiadomienia e-mail o każdej nowej ofercie opublikowanej w serwisie MyFleetHub.",
    },
    select: "Tout cocher",
    ssoLogin: "Se connecter avec Azure AD",
    rgpd:
      "Akiem zobowiązuje się do przestrzegania w uczciwy i przejrzysty sposób przepisów dotyczących ochrony danych osobowych, " +
      'w szczególności ogólnego rozporządzenia o ochronie danych ("GDPR"). Na tym portalu nie używamy plików cookie. ' +
      "W związku z tym żadne dane osobowe użytkownika nie są gromadzone podczas sesji logowania ani przechowywane po jej " +
      'zakończeniu. Użytkownik zostanie poproszony o wyrażenie zgody na korzystanie z funkcji "ankiety satysfakcji".',
    login: {
      welcomeFirst: "witamy w",
      welcomeSecond: "espace client",
      id: "Login",
      pw: "Moje hasło",
      restore: "Przywróć moje hasło",
      validate: "Vatwierdzić",
      errorLogin: "Le mot de passe est éronné, merci de recommencer",
      initMsg:
        "Veuillez renseigner votre mot de passe pour finaliser la creation de votre compte",
    },
    aside: {
      home: "Home",
      notice: "Instrukcja obsługi",
      logout: "Wylogowanie",
      account: "Moje konto",
      config: "Configuration",
      profil: "Informacje o profilu",
      alert: "Mes alertes",
      parc: "Mój park",
      planning: "Mon planning",
      detail: "Szczegóły dotyczące mojej floty",
      geo: "Zlokalizuj  flotę",
      board: "Pulpit nawigacyjny",
      km: "śledzony km",
      hm: "Godziny pracy silnika",
      battery: "informacja o akumulatorze",
      mint: "My MINT",
      magic: "Interwencje i utrzymanie ",
      history: "Historia",
      infoloc: "Informacje o lokomotywie",
      fleetcontrol: "Kontrola floty",
      unleased: "Flota nieleasingowana",
      doc: "Moje dokumenty",
      edl: "Inwentaryzacja urządzeń / Certyfikaty",
      certificat: "Certyfikaty",
      jobplan: "Nadchodzące prace utrzymaniowe",
      krefeldplan: "Krefeld plan",
      batterytable: "Ostatnie odczyty baterii",
      geofencing: "Geofencing",
      disponibility: "Dostępność kontraktowa",
      admin: "Internal menu",
      locoInternal: "Utwórz zgłoszenie na infolinię",
      userlist: "Lista użytkowników",
    },
    superuser: {
      profile: "Profil",
      action: "Działanie",
      updateprofile: "Edycja",
      administrator: "Administrator",
      management: "Manager",
      operational: "Szef operacyjny",
      commercial: "Handlowiec",
      delmessage1: "Zamierzasz zażądać usunięcia konta",
      delmessage2:
        "Wiadomość zostanie wysłana do działu IT firmy Akiem, który usunie konto. Użytkownik",
      delmessage3:
        "nie będzie już miał dostępu do portalu klienta My Fleet hub. Jeśli użytkownik chce ponownie utworzyć konto w późniejszym terminie, powinien skontaktować się ze swoim kierownikiem ds. umowy serwisowej. Czy chcesz kontynuować?",
      legendmgt:
        "Profil Manager może przeglądać wszystkie moduły portalu. Może zatwierdzać dodatkowe zadania.",
      legendcom:
        "Profil Handlowiec może przeglądać wszystkie moduły portalu. Nie może zatwierdzić wniosku o wykonanie uslugi i potwierdzenie kosztow.",
      legendoper:
        "Profil Szef operacyjny może przeglądać wszystkie moduły portalu z wyjątkiem modułu « wniosku o wykonanie uslugi i potwierdzenie kosztow ».",
    },
    geofencing: {
      select: "Wybierz wartość",
      entry: "Data i godzina wejścia",
      exit: "Data i godzina wyjścia",
      dbenergy: "Czy zastanawiałeś się nad złożeniem deklaracji DB Energy?",
    },
    header: {
      language: "Języki",
    },
    home: {
      team: "Dedykowana ekipa Akiem",
      name: "Nazwisko",
      firstname: "Imię",
      function: "Funkcja",
      fixphone: "Tel. stacjonarny",
      mobilephone: "Telefon komórkowy",
      mail: "E-mail",
      locoInfo: "Utwórz szybkie zgłoszenie serwisowe",
    },
    page: {
      assignment: "Przydział",
      customer: "Portail",
      portal: "Client",
      availableLoco: "Utrzymywane przez AKIEM",
      loconumber: "Liczba lokomotyw",
      status: "Status operacyjny",
      available: "Dostępne ",
      maintenance: "w utrzymaniu",
      connexionDate: "Data ostatniego połączenia",
      findLocation: "Znaleźć lokalizację taboru kolejowego",
      contractNumber: "Numer umowy",
      serial: "Série",
      contractStatus: "Status umowy",
      startDate: "Data rozpoczęcia",
      endDate: "Data końcowa",
      delta:
        "En sélectionnant une plage de dates, vous obtiendrez un tracé de votre parcours",
      locate: "Lokalizacja",
      titular: "Posiadacz",
      reserve: "Rezerwa",
      spot: "Spot",
      performance: "Wydajność",
      cumulTitle: "Kilomètres cumulés par locomotive",
      cumul: "km skumulowane",
      distance: "Odległość",
      moyMonth: "średnia liczba przejechanych km / miesiąc",
      filterMsg: "Wybierając jedną lokomotywę, otrzymasz mapę trasy",
      availableNotice: '"Ne comprend pas les signalements en compte"',
      doctype: "Rodzaj dokumentu",
      contractType: "Contract type",
    },
    opinionGlobal: {
      opinion: "moja opinia na temat portalu",
      opinionFirst: "moja opinia na",
      opinionSecond: "temat portalu",
      opinionRedirectionOne: "zostaniesz przekierowany na stronę zewnętrzną,",
      opinionRedirectionTwo: " czy chcesz kontynuować?",
      opinionClic:
        "Klikając na ten link, wyrażasz zgodę na opuszczenie tego portalu w celu uzyskania dostępu " +
        "do platformy Eval N Go na potrzeby tego badania satysfakcji, a tym samym wyrażasz zgodę na przetwarzanie swoich danych osobowych.",
      opinionPersonelData: "Gromadzone dane osobowe są następujące :",
      opinionMail: "Adresy e-mail",
      opinionName: "Nazwa",
      opinionDataTransmission:
        "Dane te są przekazywane wyłącznie osobom upoważnionym przez Akiem, które podlegają obowiązkowi " +
        "zachowania poufności, i są przechowywane przez okres 1 roku.",
      opinionStock:
        "Jest on przechowywany we Francji i nie będzie transmitowany poza UE.",
      opinionRules:
        "Zgodnie z obowiązującym prawem, użytkownik ma prawo do kontroli swoich danych osobowych " +
        "(prawo dostępu, sprostowania itp.), z którego może skorzystać wysyłając e-mail na adres dpo@akiem.com.",
      opinionHelp:
        "Pomoże nam to poczynić dalsze postępy w sposobie, w jaki udzielamy wsparcia, " +
        "i lepiej zrozumieć Twoje potrzeby - Twój wkład będzie dla nas cenną pomocą.",
      opinionYes: "Tak",
      opinionNo: "Nie",
    },
    pageKm: {
      trackingKm: "Suivi des kilomètres",
      tableKm: "Tableau des kilomètres",
      status: "Status umowy",
      serial: "Numer seryjny",
      contract: "Contrats",
      contractnum: "Numer umowy",
      total: "Całkowita liczba kilometrów",
      loco: "Lokomotywy",
      date: "Data",
      since: "Od",
      kmNotice: '"Kilomètres relevés selon les données Railster transmises" ',
    },
    pageHm: {
      title: "Godziny pracy silnika",
      lastcheck: "Najnowsze dane",
      cumulativeHm: "Łączna liczba godzin pracy silnika",
      hm: "Godziny pracy silnika",
      total: "Łączna liczba godzin pracy silnika",
      portalReal: "odczyty pobrane z portalu",
      maintenanceReal: "odczyty wykonane podczas konserwacji",
      detailHm: "Szczegóły dotyczące godzin pracy silnika",
    },
    maintenance: {
      workshops: "Warsztaty utrzymaniowe",
    },
    pageAlert: {
      alert: "Moje powiadomienia",
      inout: "Wejścia i Wyjścia lokomotyw",
      serial: "Sur une série",
      contract: "Sur un contrat",
      loco: "Sur les locs de mon parc",
      mail: "Activer alertes mail",
      sms: "Activer alertes sms",
      battery: "alarmy dotyczące baterii",
    },
    passwordResetPage: {
      first: "Veuillez renseigner votre mot de passe",
      confirm: "mot de passe confirmation",
      pwRuleOne: "mot de passe requis",
      pwRuleTwo: "8 caractères minimum",
      pwRuleThree:
        "Le mot de passe doit contenir au moins une lettre minuscule, un chiffre, un caractère spécial et une lettre majuscule",
      pwConfirmOne: "la confirmation du mot de passe est requise",
      pwConfirmTwo: "La confirmation du mot de passe ne correspond pas",
      pwSuccess: "Mot de passe reinitialisé avec success",
      validate: "Valider",
    },
    pageNotice: {
      second:
        "Dane, informacje i/lub dokumenty zamieszczone na tym Portalu " +
        "i/lub dostępne za jego pośrednictwem są publikowane wyłącznie w celach informacyjnych i nie mają wartości umownej.",
      third:
        "Odnośne dane, informacje i/lub dokumenty mogą zawierać nieścisłości i błędy. Mogą one zostać w dowolnym " +
        "momencie zmienione przez firmę Akiem i mogą podlegać aktualizacji. Zaleca się sprawdzanie prawidłowości " +
        "i trafności informacji i/lub dokumentów udostępnionych na tym Portalu.",
      fourty:
        "Korzystanie z danych, informacji i/lub dokumentów dostępnych na Portalu odbywa się na wyłączną " +
        "odpowiedzialność użytkownika Portalu, który ponosi wszelkie konsekwencje, jakie mogą z tego wyniknąć, " +
        "bez możliwości pociągnięcia firmy Akiem do odpowiedzialności w tym zakresie i bez możliwości dochodzenia roszczeń wobec Akiem.",
      fifty:
        "Akiem nie ponosi odpowiedzialności za jakiekolwiek szkody wynikające z " +
        "interpretacji lub wykorzystania informacji i/lub dokumentów dostępnych na niniejszym Portalu.",
      sixty:
        "Portal jest co do zasady dostępny 24 godziny na dobę, 7 dni w tygodniu, z wyjątkiem przypadków działania siły " +
        "wyższej lub zdarzeń niezależnych od Akiem, a także z zastrzeżeniem ewentualnych awarii i czynności konserwacyjnych " +
        "niezbędnych do prawidłowego funkcjonowania Portalu, dla Użytkowników posiadających dostęp do Internetu. Akiem zastrzega sobie prawo " +
        "do przerwania, czasowego zawieszenia lub modyfikacji dostępu do całości lub części Portalu w dowolnym momencie i bez wcześniejszego powiadomienia, w" +
        " celu zapewnienia jego konserwacji lub z jakiegokolwiek innego powodu, przy czym przerwa nie skutkuje powstaniem jakichkolwiek zobowiązań ani prawa do odszkodowania.",
      seventy:
        "Firma Akiem zobowiązuje się do uczciwego i przejrzystego przestrzegania przepisów dotyczących ochrony danych osobowych, w szczególności ogólnego  " +
        "rozporządzenia o ochronie danych („RODO”). Firma Akiem wdrożyła środki techniczne i organizacyjne w celu zapewnienia ochrony danych użytkownika przed " +
        "nieuprawnionym dostępem oraz wszelkimi innymi zagrożeniami bezpieczeństwa i lukami w zabezpieczeniach komputerowych.",
      eighty:
        "Na Portalu nie używamy plików cookie. W związku z tym żadne dane osobowe użytkownika nie są gromadzone podczas sesji logowania ani przechowywane " +
        "po jej zakończeniu. W przypadku chęci skorzystania z funkcji „ankiety satysfakcji” użytkownik zostanie wyraźnie poproszony o wyrażenie zgody.",
    },
    magic: {
      workorderTitle: "Tytuł interwencji",
      workorder: "Interwencji",
      startDate: "Data rozpoczęcia",
      endDate: "Data końcowa",
      meter: "Kilometry",
      hours: "Godziny pracy silnika",
      technicDoc: "Dokumentacja techniczna",
      restriction: "Restriction/Reason",
      date: "Data",
      asset: "Materiel roulant",
      km: "KM",
      leftD1: "D1 gauche",
      leftD2: "D2 gauche",
      leftD3: "D3 gauche",
      leftD4: "D4 gauche",
      rightD1: "D1 droit",
      rightD2: "D2 droit",
      rightD3: "D3 droit",
      rightD4: "D4 droit",
      action: "Action",
      description: "Podsumowanie - lokalizacja",
      desc: "Podsumowanie",
      addFile: "dodaj załącznik",
      reportBy: "Signalé par",
      id: "ID",
      status: "Status",
      sr: "wpis",
      srAttechement: "Powiązane wpisy",
      attachements: "Załączniki",
      mileage: "Dane eksploatacyjne",
      createAlert: "Utwórz wpis",
      title: "Tytuł",
      location: "Lokalizacja",
      priority: "Priorytet",
      addKm: "Przekazać dane eksploatacyjne",
      newKm: "Nowa wartość",
      lastreading: "Wartość bieżąca",
      scheduleDate: "Terminy planowania",
      metername: "Typ oświadczenia",
      executeDate: "Terminy realizacji",
      error: "Operacja nie powiodła się",
      success: "Operacja została zarejestrowana",
      attachment: "Dodaj załącznik",
      unit: "Jednostka",
      source: "źródło",
      jobplan: "Job plan type",
      type: "Typ",
      reportedDate: "Data utworzenia",
      details: "Szczegóły",
      hotline: "Zgłoszenie do infolinii",
    },
    assetStatus: {
      operating: "Operating",
      maintenance: "Maintenance",
      limitedUse: "limited use",
      blocked: "Blocked",
    },
    button: {
      submit: "Zatwierdzić",
      cancel: "Anuluj",
    },
    search: "Szukaj",
    history: {
      pm: "Historia interwencji prewencyjnych",
      cm: "Historia interwencji korekcyjnych",
    },
    infoloc: {
      infoOp: "Informacje operacyjne",
      infoTech: "Informacje techniczne",
      cert: "Homologacje",
      openSr: "Signalements ouverts",
      sr: "Wpisy",
      dateAndKm: "Daty i przebieg",
      pmPlan: "Plan de maintenance prévisionnelle",
      locomotive: "sprawdź wszystko",
      actWorkorder: "Interwencja w toku",
      outPrevDate: "Przewidywana data zakończenia",
      nextWorkDate: "Następna konserwacja",
      wheelset: "Informacje o zestawach kołowych",
      unitToGo: "Pozostałe km",
      engineeringvariant: "Engineering variant",
      softwareversion: "Software version",
      hkm: "historia przebiegu",
      hhm: "historia godzin pracy silnika",
      fuellevel: "Poziom fioul",
      parking: "poza napieciem",
      traction: "w ruchu, lokomotywa ciagnaca",
      vehicle: "w ruchu, lokomotywa wagon",
      poweron: "postoj pod napieciem",
      standby: "postoj pod napieciem",
    },
    status: {
      approved: "Confirmed appointment",
      canceled: "Anulowane",
      ccanceled: "Appointment canceled by customer",
      completed: "Status according desicion ECM 3",
      inprogress: "Under maintenance",
      wait: "forcast planing, upcoming maintenance",
      new: "Nowy",
      sinprogress: "W trakcie realizacji",
      closed: "Zrealizowane",
    },
    woStatus: {
      WSCH: "W planowaniu ",
      WAPPR: "W planowaniu ",
      WPCOND: "W planowaniu ",
      CLOSE: "Zakonczono ",
      COMP: "Zakonczono ",
      INPRG: "W trakcie",
      REVIEWED: "Zakonczono / w trakcie ",
      WCOE: "W oczekiwaniu na cene czesci zamiennych",
      WMATL: "W oczekiwaniu na cene czesci zamiennych",
      APPR: "Zatwierdzono",
      CA: "Anulowano ",
      NOTPERF: "Nie zrealizowano ",
      CAN: "Anulowano",
    },
    doc: {
      certificat: {
        delivry: "Certyfikaty dostaw",
        redelivry: "Certyfikaty zwrotne ",
      },
      type: "Rodzaj dokumentu ",
      edl: {
        delivry: "Certyfikat dostawy",
        redelivry: "Certyfikat odbioru",
        genralInfo: "Informacje ogólne",
        technicalInfo: "DANE TECHNICZNE ",
        signature:"PODPIS",
        asOf:"W dniu ",
        andAccording: "zgodnie z postanowieniami umowy ",
        contractRes: "numer",
        representBy:"spółka Akiem reprezentowana przez Sebastian Rodriguez",
        delivryTo: "przekazuje spółce",
        society:"spółka",
        lessee: " ",
        delivryToAkm:"przekazuje spółce AKIEM reprezentowanej przez Sebastian Rodriguez",
        locomotive: "lokomotywę",
        locoType: "lokomotywę typu",
        delivryAt: "w",
        redelivryAt:"przyjętą przez wynajmującego w:",
        restDerog:"Restrykcje/Ograniczenia",
        comment:"Uwagi",
        edl:"Załączony protokół przekazania",
        remark:"Uwaga",
        rem1:"Zgodnie z postanowieniami umowy, lokomotywa musi być ubezpieczona najpóźniej od daty przekazania widniejącej na protokole zdawczo-odbiorczym.",
        rem2:"Obowiązek pieczy nad lokomotywą przechodzi na Najemcę z dniem dostawy określonym w niniejszym dokumencie.",
        kmCompteur: "Przebieg (km)",
        hmMoteur: "Godziny pracy silnika",
        wheelset: "Zestawy kołowe",
        recentData: "ostatnie znane dane*",
        subjectTo: "*O ile strony nie ustaliły inaczej przy przekazaniu lokomotywy.",
        lastRecord: "data pomiaru",
        date:"Data",
        defaultMes:"W przypadku braku zgłoszenia zastrzeżeń do protokołu w ciągu 48 godzin od jego otrzymania, niniejszy dokument zostanie uznany za wiążący.",
        addBill:"Najemca może zostać obciążony dodatkowymi kosztami związanymi z naprawą uszkodzeń lokomotywy powstałych w czasie najmu, za które ponosi odpowiedzialność.",
        yes: "TAK",
        no: "NIE",
        reserv: "Zgłaszam zastrzeżenie",
        reject: "Reserves issued"
      },
    },
    doctypes: [
      {
        key: "DELIVERY (EXCEPT NEW)",
        value: "Stan lokomotywy przy dostawie",
      },
      {
        key: "REDELIVERY,RESTITUTION",
        value: "Stan lokomotywy przy odbiorze",
      },
      {
        key: "Prima Delivery Certificate,Traxx Delivery Certificate",
        value: "Certyfikaty dostaw",
      },
      {
        key: "Prima Redelivery Certificate,Traxx Redelivery Certificate",
        value: "Certyfikaty zwrotne",
      },
    ],
    poi: {
      workshop: "Wejścia/Wyjazdy Warsztaty",
      entry: "Przewidywane wejście w dniu",
      exit: "Wyjście szacowane na",
      at: "o godz",
    },
    extrawork: {
      title: "Moje wnioski o wykonanie uslugi i pokrycie kosztow",
      newquote: "NOWE WYCENY",
      quotewaiting: "OCZEKUJĄCE NA ZATWIERDZENIE",
      messageconfirm: "Wprowadź numer zamówienia",
      confirm: "Potwierdzenie",
      reject: "Odrzucić",
      cancel: "Anulować",
      whyreject:
        "Z jakiego powodu wniosek o wykonanie uslugi i potwierdzenie kosztow  jest odrzucony",
      rejectcomment: "Zostaw komentarz",
      quotenum: "Nr kosztorysu",
      quotetitle: "Tytuł oferty",
      quoteprice: "Cena z wył.",
      quotestatus: "Status oferty",
      realisationdate: "Rzeczywista realizacja",
      customerpo: "Klient Po",
      tovalidate: "Oczekuje na zatwierdzenie",
      validated: "Zaakceptowany",
      rejected: "Odrzucony",
      quoterejected: "Odrzucony",
      quotesrejected: "Odrzucone oferty",
      comment: "komentarz",
      unitprice: "Ceny jednostkowe",
      service: "Usługi",
      quantity: "Ilość",
      totalprice: "Cena całkowita",
      quotetotalprice: "Całkowity koszt oferty",
      statusbilled: "zafakturowane",
      statusvalidated: "zatwierdzone ",
    },
    dispoc: {
      past: "Poprzedni przydział",
      widgetText: "Zobacz moją dostępność kontraktową",
      taux: "Odsetek",
      recapLoc: "Dostępność",
      ticmp: "Odsetek niedostępności, utrzymanie prewencyjne",
      timcc: "Odsetek niedostępności, utrzymanie korekcyjne",
      ticc: "Odsetek niedostępności, przyczyny zależne od klienta",
      locDisp: "Dostępna",
      locTot: "Całkowita liczba",
      week: "Tydzień",
      ldispo: "Dostępna",
      ldmd: "Dostępna w trybie pogorszonym",
      lmp: "Utrzymanie prewencyjne",
      lmc: "Utrzymanie korekcyjne",
      lach: "Transport",
      lmcc: "U. z przyczyn zależnych od klienta",
      indisponibilite: "Niedostępna",
      dispGen: "Dostępność globalna",
      causeCorrective: "utrzymanie korekcyjne",
      causePreventive: " utrzymanie prewencyjne",
      causeClient: "przyczyna zależna od klienta",
    },
  },
};

export default PL;
